/* ARI Spin the 42 (v3.8): the countdowns, the chip, and the wording elsewhere that follows the game.
   Loaded on every page, game on or off. assets/ari-spin42.js tells it what changed with an "a42:change" event. */
(function () {
  'use strict';
  var st = { code: '', exp: 0, at: 0, pool: 0, open: false, design: false }, applied = false, timer = null, cartT = null;
  function all(s) { return document.querySelectorAll(s); }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function hms(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60]; }
  function put(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function live() { return !!(st.code && st.exp * 1000 > Date.now()); }

  /* wording marked data-a42-show="live" / "off" follows what the browser knows about the game */
  function sync() {
    var on = !!window.ARI_SPIN42_LIVE, els = all('[data-a42-show]');
    for (var i = 0; i < els.length; i++) els[i].hidden = (els[i].getAttribute('data-a42-show') === 'live') !== on;
  }

  function paint() {
    var now = Date.now(), left = st.exp * 1000 - now, i, p;
    /* plain clocks: data-a42-clock="pool" counts to tonight's deadline, "code" to the player's own */
    var cl = all('[data-a42-clock]');
    for (i = 0; i < cl.length; i++) {
      p = hms(cl[i].getAttribute('data-a42-clock') === 'pool' ? st.pool * 1000 - now : left);
      put(cl[i], p[0] + ':' + two(p[1]) + ':' + two(p[2]));
    }
    p = hms(left);
    var d = ['h', 'm', 's'];
    for (i = 0; i < 3; i++) put(document.querySelector('[data-a42-' + d[i] + ']'), two(p[i]));
    /* phase: lead, then the last hour, then the last ten minutes. Each box carries its own wording for them. */
    var phase = left <= 0 ? 'over' : left <= 6e5 ? 'ten' : left <= 36e5 ? 'hour' : 'lead', box = all('[data-a42-phase]');
    for (i = 0; i < box.length; i++) {
      box[i].setAttribute('data-a42-phase', phase);
      var lab = box[i].querySelector('[data-a42-timerlabel]');
      var txt = box[i].getAttribute(applied && phase !== 'over' && box[i].hasAttribute('data-applied') ? 'data-applied' : 'data-' + phase);
      if (lab && txt) put(lab, txt);
      box[i].classList.toggle('is-applied', applied);
    }
    /* the bar is the share of the code's own life that is left */
    var span = st.exp * 1000 - (st.at || now), pct = span > 0 ? Math.max(0, Math.min(100, left / span * 100)) : 0, bar = all('[data-a42-fuel]');
    for (i = 0; i < bar.length; i++) bar[i].style.width = pct.toFixed(1) + '%';
    var chip = document.querySelector('[data-a42-chip]');
    if (chip) chip.hidden = !(live() && !st.open && !st.design && !/^\/(checkout|account)/.test(location.pathname));
    if (timer && !live() && !(st.open && st.pool * 1000 > now)) { clearInterval(timer); timer = null; }
  }
  function run() {
    paint();
    if (!timer && (live() || (st.open && st.pool * 1000 > Date.now()))) timer = setInterval(paint, 1000);
  }

  /* is the code on the cart and taking money off? The chip says so. */
  function cart() {
    if (!live() || !window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var on = false, dc = c.discount_codes || [];
        for (var i = 0; i < dc.length; i++) if (dc[i].code === st.code && dc[i].applicable) on = true;
        if (on !== applied) { applied = on; paint(); }
      })
      .catch(function () {});
  }
  function cartSoon() { clearTimeout(cartT); cartT = setTimeout(cart, 700); }

  document.addEventListener('a42:change', function (e) {
    var d = e.detail || {};
    for (var k in st) if (k in d) st[k] = d[k];
    run();
    if (d.cart) cartSoon();
  });
  /* the theme announces a cart change when it starts, not when it lands, so look twice */
  function cartChanged() { clearTimeout(cartT); cartT = setTimeout(cart, 1500); setTimeout(cart, 4500); }
  document.addEventListener('shopify:cart:lines-update', cartChanged);
  document.addEventListener('shopify:cart:discount-update', cartChanged);
  /* a link to the game that can't open it (switched off, no codes today) goes to the VIP section instead */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#spin42"]');
    if (!a) return;
    e.preventDefault();
    setTimeout(function () { var g = document.getElementById('a42'); if (!g || g.hidden) location.href = '/#vip'; }, 0);
  });

  function boot() {
    sync();
    if (window.ARI_SPIN42) st.pool = window.ARI_SPIN42.exp || 0;
    try {
      var j = JSON.parse(localStorage.getItem('ari42') || '{}') || {};
      if (j.code && j.exp * 1000 > Date.now()) { st.code = j.code; st.exp = j.exp; st.at = j.at || 0; }
    } catch (e) {}
    run();
    cartSoon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();